import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from 'src/lib/utils';

const fillVariants = cva('h-full rounded-full transition-[width] duration-700 ease-out', {
  variants: {
    scope: {
      scope1: 'bg-gradient-to-r from-foreground to-accent',
      scope2: 'bg-gradient-to-r from-primary to-primary',
      scope3: 'bg-gradient-to-r from-primary to-primary/80',
      amber: 'bg-gradient-to-r from-secondary to-secondary/90',
      danger: 'bg-gradient-to-r from-destructive to-destructive/90',
    },
  },
  defaultVariants: {
    scope: 'scope1',
  },
});

const EmissionBar = React.forwardRef(function EmissionBar({ className, label, value, displayValue, scope, ...props }, ref) {
  return (
    <div ref={ref} className={cn('mb-3.5', className)} {...props}>
      <div className='flex justify-between items-baseline mb-1.5'>
        <span className='text-[13px] font-medium'>{label}</span>
        {displayValue && <span className='font-mono text-xs text-muted-foreground'>{displayValue}</span>}
      </div>
      <div className='h-2.5 bg-muted rounded-full overflow-hidden'>
        <div className={fillVariants({ scope })} style={{ width: `${Math.min(100, Math.max(0, value || 0))}%` }} />
      </div>
    </div>
  );
});

export { EmissionBar };
